<template>
  <div class="pos-h5" ref="posH5">
    <div class="fppos">
      <div class="text">
        <div class="t1">{{ $t('丰派云POS') }}</div>
        <div class="t2">
          {{ $t('丰派云POS是专注零售领域的新零售SaaS系统，支持POS称重收银一体、进销存管理、全渠道营销、大数据BI分析、对接主流外卖平台、无人云值守等业务，助力中小型零售企业管理运营，为企业赋能增值，实现快速开店，轻松管店。') }}
        </div>
      </div>
      <div class="btn" @click="goto">{{ $t('免费使用') }}</div>
    </div>
    <div class="pos-ji">
      <div class="box-img">
        <img src="~@/assets/pos-img.png" class="img" alt="" />
      </div>
    </div>

    <div class="industry">
      <div class="text">
        <div class="t1">{{ $t('行业一键开店') }}</div>
        <div class="t2">{{ $t('支持零售、餐饮、服饰、母婴等多行业') }}</div>
      </div>
      <div class="img-box-list">
        <div class="img-box">
          <img src="~@/assets/blscH5.png" class="img" alt="" />
        </div>
        <div class="title">{{ $t('便利商超') }}</div>
      </div>
      <div class="img-box-list">
        <div class="title title1">{{ $t('美食餐饮') }}</div>
        <div class="img-box">
          <img src="~@/assets/mscyH5.png" class="img" alt="" />
        </div>
      </div>
      <div class="img-box-list">
        <div class="img-box">
          <img src="~@/assets/fsxbH5.png" class="img" alt="" />
        </div>
        <div class="title">{{ $t('服饰鞋包') }}</div>
      </div>
      <div class="img-box-list img-box-list1">
        <div class="title title1">{{ $t('亲子母婴') }}</div>
        <div class="img-box">
          <img src="~@/assets/qzmyH5.png" class="img" alt="" />
        </div>
      </div>
    </div>
    <div class="hardware">
      <div class="text">
        <div class="t1">{{ $t('硬件商业级兼容性') }}</div>
        <div class="t2">
          {{ $t('丰派POS收银软件兼容市面上开店所需的扫描枪、钱箱、小票机、顾客显示器、标签机、通讯秤、AI智能秤等主流设备品牌') }}
        </div>
      </div>
    </div>
    <div class="feature">
      <div class="text">
        <div class="t1">{{ $t('系统特色') }}</div>
        <div class="t2">{{ $t('一秒了解丰派云POS收银系统') }}</div>
      </div>
      <div class="feature-box">
        <div class="img-box">
          <img src="~@/assets/system1.png" class="img" alt="" />
        </div>
        <div class="text-box">
          <div class="title">{{ $t('全新界面') }}</div>
          <div class="txt">
            {{ $t('界面全新升级，操作简单，用户可以快速上手，告别繁杂的培训学习') }}
          </div>
        </div>
      </div>
      <div class="feature-box">
        <div class="img-box">
          <img src="~@/assets/system2.png" class="img" alt="" />
        </div>
        <div class="text-box">
          <div class="title">{{ $t('一体化营销') }}</div>
          <div class="txt">
            {{ $t('公众号、小程序、微信群、企业微信互联互通，流量变现快速高效，促销多样化') }}
          </div>
        </div>
      </div>
      <div class="feature-box">
        <div class="img-box">
          <img src="~@/assets/system3.png" class="img" alt="" />
        </div>
        <div class="text-box">
          <div class="title">{{ $t('开放式API对接') }}</div>
          <div class="txt">
            {{ $t('开放API支持打通各大会员系统、供应链、WMS系统、TMS系统等') }}
          </div>
        </div>
      </div>
      <div class="feature-box">
        <div class="img-box">
          <img src="~@/assets/system4.png" class="img" alt="" />
        </div>
        <div class="text-box">
          <div class="title">{{ $t('全新框架') }}</div>
          <div class="txt">
            {{ $t('云技术高性能框架搭建的收银系统，性能稳定，简单易用，各机构数据实时同步') }}
          </div>
        </div>
      </div>
      <div class="feature-box">
        <div class="img-box">
          <img src="~@/assets/system5.png" class="img" alt="" />
        </div>
        <div class="text-box">
          <div class="title">{{ $t('云端同步') }}</div>
          <div class="txt">
            {{ $t('采用全新同步技术和增加本地缓存库，遇到断网等突发情况开启自动保护机制') }}
          </div>
        </div>
      </div>
      <div class="feature-box feature-box1">
        <div class="img-box">
          <img src="~@/assets/system6.png" class="img" alt="" />
        </div>
        <div class="text-box">
          <div class="title">{{ $t('硬件无忧') }}</div>
          <div class="txt">
            {{ $t('兼容Windows、苹果IOS、安卓，不管使用什么设备，都有对应的客户端为您快速提升效率') }}
          </div>
        </div>
      </div>
    </div>
    <div class="report">
      <div class="text">
        <div class="t1">{{ $t('更全面的分析报表') }}</div>
        <div class="t2">
          {{ $t('更直观地了解数据，多对象、多角度地深挖营业数据价值，为商品结构调整、消费定位、营销活动、市场推广等方面做好第一手调研。') }}
        </div>
      </div>
      <div class="img-box">
        <img src="~@/assets/reportH5.png" class="img" alt="" />
      </div>
    </div>
    <div class="function">
      <div class="text">
        <div class="t1">{{ $t('功能强大的收银系统') }}</div>
        <div class="t2">{{ $t('足不出户管理门店，让O2O没有门槛。') }}</div>
        <div class="t2">
          {{ $t('丰派云POS收银系统内置多种功能模块，在家就可以管理门店，随时随地查看销售数据、库存信息、员工信息各种信息尽在掌控，帮助企业全方位管理收银系统。') }}
        </div>
      </div>
      <div class="function-list">
        <div
          class="function-item"
          v-for="item of functionList"
          :key="item.tabel"
        >
          <img :src="item.url" alt="" class="img" />
          <div class="txt">{{ item.table }}</div>
        </div>
      </div>
      <div class="function1-list">
        <div
          class="function-item"
          v-for="item of functionList1"
          :key="item.tabel"
        >
          <img :src="item.url" alt="" class="img" />
          <div class="txt">{{ item.table }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from "@/i18n";

export default {
  data() {
    return {
      functionList: [
        {
          url: require("@/assets/image1.png"),
          table: t("精选优质服务商"),
        },
        {
          url: require("@/assets/imag2.png"),
          table: t("官方检测保质"),
        },
        {
          url: require("@/assets/imag3.png"),
          table: t("官方检测保质"),
        },
        {
          url: require("@/assets/image4.png"),
          table: t("退款售后无忧"),
        },
      ],
      functionList1: [
        {
          url: require("@/assets/spgl.png"),
          table: t("商品管理"),
        },
        {
          url: require("@/assets/xsgl.png"),
          table: t("销售管理"),
        },
        {
          url: require("@/assets/yxgl.png"),
          table: t("营销管理"),
        },
        {
          url: require("@/assets/yggl.png"),
          table: t("广告推送"),
        },
        {
          url: require("@/assets/zftj.png"),
          table: t("支付统计"),
        },
        {
          url: require("@/assets/kcgl.png"),
          table: t("库存管理"),
        },
        {
          url: require("@/assets/lsgl.png"),
          table: t("连锁管理"),
        },
        {
          url: require("@/assets/yggl.png"),
          table: t("员工管理"),
        },
        {
          url: require("@/assets/hygl.png"),
          table: t("会员管理"),
        },
      ],
    };
  },
  methods: {
    goto() {
      window.open("https://www.fp1123.com/fpPos/#/regist", "_self");
    },
  },
  activated() {
    this.$refs.posH5.scrollIntoView();
  },
};
</script>

<style lang="less" scoped>
.pos-h5 {
  width: 750px;
  .fppos {
    width: 750px;
    height: 697px;
    background: url("~@/assets/posbg.png") no-repeat;
    background-size: 100% 100%;
    padding: 80px 65px;
    .text {
      text-align: center;
      .t1 {
        font-size: 64px;
        line-height: 80px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin: 42px 0;
        font-size: 26px;
        line-height: 40px;
        color: #51565d;
      }
    }
    .btn {
      cursor: pointer;
      margin: 0 auto;
      width: 288px;
      height: 88px;
      background: #336fff;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      border-radius: 6px;
      text-align: center;
      line-height: 88px;
      font-size: 32px;
      color: #fff;
    }
  }
  .pos-ji {
    width: 750px;
    height: 373px;
    background: #fff;
    position: relative;
    .box-img {
      width: 704px;
      height: 458px;
      position: absolute;
      left: 23px;
      bottom: 80px;
      .img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .industry {
    padding: 40px;
    .text {
      text-align: center;
      margin-bottom: 50px;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        font-size: 28px;
        line-height: 40px;
        color: #51565d;
        margin-top: 20px;
      }
    }
    .img-box-list {
      display: flex;
      align-items: flex-end;
      margin-bottom: 24px;
      .img-box {
        width: 440px;
        height: 280px;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        flex: 1;
        text-align: center;
        font-size: 28px;
        font-weight: 500;
        color: #292929;
        border-bottom: 1px solid #51565d;
        position: relative;
      }
      .title:before {
        position: absolute;
        bottom: 0;
        right: 0;
        content: "";
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-bottom: 10px solid #51565d;
      }
      .title1:before {
        left: 0;
      }
    }
    .img-box-list1 {
      margin-bottom: 0;
    }
  }
  .hardware {
    width: 750px;
    height: 1080px;
    background: url("~@/assets/hardware.png") no-repeat;
    background-size: 100% 100%;
    padding: 64px 65px;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        color: #292929;
        font-weight: 500;
      }
      .t2 {
        margin-top: 20px;
        font-size: 28px;
        line-height: 40px;
        color: #51565d;
      }
    }
  }
  .feature {
    background: #242933;
    padding: 80px 55px;
    .text {
      text-align: center;
      color: #fff;
      margin-bottom: 50px;
      .t1 {
        font-size: 40px;
        font-weight: 500;
        line-height: 48px;
      }
      .t2 {
        margin-top: 20px;
        font-size: 28px;
        line-height: 40px;
      }
    }
    .feature-box {
      width: 640px;
      height: 188px;
      background: linear-gradient(206.64deg, #262b37 0%, #242a35 100%);
      box-shadow: 4px 8px 20px rgba(0, 0, 0, 0.25),
        4px 8px 20px rgba(0, 0, 0, 0.25);
      border-radius: 6px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      padding: 30px 36px 30px 50px;
      .img-box {
        width: 100px;
        height: 100px;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      .text-box {
        flex: 1;
        margin-left: 48px;
        color: #fff;
        .title {
          font-size: 32px;
          line-height: 40px;
          font-weight: 500;
        }
        .txt {
          margin-top: 16px;
          margin-top: 16px;
          font-size: 26px;
          color: #bac1cb;
          line-height: 36px;
        }
      }
    }
    .feature-box1 {
      margin-bottom: 0;
    }
  }
  .report {
    width: 750px;
    padding: 80px 65px;
    background: #fff;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin-top: 20px;
        font-size: 28px;
        color: #51565d;
        line-height: 40px;
      }
    }
    .img-box {
      margin-top: 64px;
      width: 616px;
      height: 449px;
      .img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .function {
    padding: 80px 32px;
    background: linear-gradient(180deg, #f8faff 0%, #ffffff 100%);
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 500;
        color: #292929;
        margin-bottom: 24px;
      }
      .t2 {
        font-size: 28px;
        line-height: 40px;
        color: #51565d;
      }
    }
    .function-list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 64px;
      align-items: center;
      .function-item {
        width: 331px;
        display: flex;
        margin-right: 12px;
        align-items: center;
        margin-bottom: 24px;
        .img {
          width: 40px;
          height: 40px;
        }
        .txt {
          flex: 1;
          margin-left: 12px;
          font-size: 32px;
          line-height: 40px;
          color: #51565d;
        }
      }
    }
    .function1-list {
      margin-top: 64px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .function-item {
        margin-bottom: 24px;
        width: 212.67px;
        height: 200px;
        background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
        border: 4px solid #ffffff;
        box-shadow: -8px -8px 20px #ffffff, 8px 8px 20px rgba(55, 99, 170, 0.1);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img {
          width: 80px;
          height: 80px;
        }
        .txt {
          margin-top: 16px;
          font-size: 30px;
          line-height: 40px;
          color: #51565d;
        }
      }
    }
  }
}
</style>>



// WEBPACK FOOTER //
// src/h5/posH5.vue